export default __webpack_public_path__ + "static/second-image-531376e39698de5bbc3b12c8764b2b0e.gif";